"use client";

import React from "react";
import { Check, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const comparisonData = [{
  feature: "Bilingual EN/ES out of the box",
  cynergia: true,
  wix: false,
  squarespace: false,
  tenweb: false
}, {
  feature: "AI builds your site in minutes",
  cynergia: true,
  wix: true,
  squarespace: false,
  tenweb: true
}, {
  feature: "Local NYC/NJ support team",
  cynergia: true,
  wix: false,
  squarespace: false,
  tenweb: false
}, {
  feature: "WordPress backend (you own your site)",
  cynergia: true,
  wix: false,
  squarespace: false,
  tenweb: true
}, {
  feature: "Done-for-you build option",
  cynergia: true,
  wix: false,
  squarespace: false,
  tenweb: false
}, {
  feature: "Starts at",
  cynergia: "$20/mo",
  wix: "$17/mo",
  squarespace: "$23/mo",
  tenweb: "$20/mo"
}, {
  feature: "Free trial",
  cynergia: "3 days",
  wix: "14 days",
  squarespace: "14 days",
  tenweb: "7 days"
}];
export default function PricingComparison() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const renderCellContent = (value: string | boolean) => {
    if (typeof value === "boolean") {
      return value ? <Check className="mx-auto h-5 w-5 text-[#00b67a]" /> : <X className="mx-auto h-5 w-5 text-[#ff5555]" />;
    }
    return <span className="text-foreground font-medium">{value}</span>;
  };
  return;
}